import { render } from "./caseline.svg?vue&type=template&id=070553f5?inline"
const script = {}

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__